import { Tooltip } from "../Tooltip";
import { Badge, Container, TipContent } from "./styles";

export function BadgeRoot({ name, title, zIndex, ...rest }) {
  return (
    <Container>
      {!!name && !!title && (
        <Tooltip.Root name={name} side="top" sideOffset={18} zIndex={zIndex}>
          <TipContent>{title}</TipContent>
        </Tooltip.Root>
      )}

      <Tooltip.Trigger tooltipName={name} asChild >
        <Badge data-type="badge" {...rest} />
      </Tooltip.Trigger>
    </Container>
  );
}
